export default __webpack_public_path__ + "assets/images/c703eca4072295d74a92353f5ff65453.svg";